// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"299":"0ef26cc1","613":"9dfa0473","672":"abdf9659","862":"e36983dd","928":"b4c1b975"}[chunkId] + ".css";
};